import type { FieldPath } from "./types";

// Canonical signal is the schema's `format: "password"`; these name/label
// heuristics are a backstop for backend schemas that omit it. Bias toward
// masking — a false mask is harmless, a missed one leaks a credential.
const SECRET_PROPERTY_NAMES = new Set([
  "cr_token",
  "cr_secret",
  "passphrase",
  "password",
  "secret",
  "api_key",
  "api_secret",
  "secret_key",
  "private_key",
  "signing_key",
]);
const SECRET_LABEL_PATTERN =
  /token|passphrase|password|onepass|secret|api[_\s-]?key|private[_\s-]?key|signing[_\s-]?key/i;
const SECRET_PATH_TOKENS = [...SECRET_PROPERTY_NAMES];

export function isSecretField(opts: {
  schema: any;
  label?: string;
  fieldName: string;
  path: FieldPath;
}): boolean {
  const { schema, label, fieldName, path } = opts;
  const schemaTitle = schema?.title ?? "";
  const pathStr = path.map(String).join(".");
  if (schema?.format === "password") return true;
  if (SECRET_PROPERTY_NAMES.has(fieldName)) return true;
  if (SECRET_PATH_TOKENS.some((t) => pathStr.includes(t))) return true;
  if (label && SECRET_LABEL_PATTERN.test(label)) return true;
  if (typeof schemaTitle === "string" && SECRET_LABEL_PATTERN.test(schemaTitle))
    return true;
  return false;
}
